import React, { useEffect, useState } from 'react';
import { useQBCallback } from '../api/getTransacations';
import { HOST_URL } from '@/config';
import { useSearchParams } from 'react-router-dom';
import { Loader } from '@/components/Loader/Loader';
import AppLogo from '@/assets/img/p-logo.svg';

import './qbCallback.scss';
export default function QbCallback() {
  const qbAuthMutation = useQBCallback();
  const [searchParams, setSearchParams] = useSearchParams();
  const [apiSuccess, setApiSucess] = useState<boolean>();
  useEffect(() => {
    initialCallback();
  }, []);
  const initialCallback = async () => {
    try {
      const url = new URL(window.location.href);
      const args = new URLSearchParams(url.search);
      if (args.get('error')) {
        window.opener && window.opener.parent.postMessage({ error: 'Access Denied' }, HOST_URL);
      } else {
        const res = await qbAuthMutation.mutateAsync({ searchQuery: window.location.search });
        if (res) {
          if (res.success) {
            setApiSucess(true);
            setSearchParams({
              success: 'true',
            });
          }
          window.opener && window.opener.parent.postMessage({ res }, HOST_URL);
        }
      }
    } catch (e: any) {
      console.log('e', e);
    }
  };
  return (
    <div className="qb-callback-container">
      {qbAuthMutation.isLoading && <Loader text="" />}
      {apiSuccess && (
        <div className="success">
          <img src={AppLogo} className="logo-icon" />
          <h3>
            Quick Book Authentication is successfull! <br />
            <br /> You can close this window if it doesn&apos;t closes automatically.
          </h3>
        </div>
      )}
    </div>
  );
}
